/******************************************************************
 * Archivo : client/src/queries/dinamico/fetchDynamicSurveysByIds.js
 * Proyecto: CB30
 * Módulo  : Visor Dinámico
 *
 * Propósito:
 * Obtener en una sola consulta las encuestas seleccionadas y
 * sus preguntas para la segunda pantalla del Visor Dinámico.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query DynamicSurveysByIdsQuery($surveyIds: [ID!]!) {
    dynamicSurveys(surveyIds: $surveyIds) {
      id
      titulo
      descripcion

      fieldcollection {
        id
        type
        inputName
        question

        answers {
          label
          value

          config {
            replica
            replicaLabel
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/dinamico/fetchDynamicSurveysByIds.js